export const FTBL_PROJECT_TYPE_PLAYER = 'ftbl-player';
export const FTBL_PROJECT_TYPE_MATCH = 'ftbl-match';

export const isFtblPlayerProject = (projectType?: string | null): boolean =>
    projectType === FTBL_PROJECT_TYPE_PLAYER;

export const isFtblMatchProject = (projectType?: string | null): boolean =>
    projectType === FTBL_PROJECT_TYPE_MATCH;

export const isFtblProject = (projectType?: string | null): boolean =>
    isFtblPlayerProject(projectType) || isFtblMatchProject(projectType);
export const FTBL_PROJECT_TYPE_PLAYER = 'ftbl-player';
export const FTBL_PROJECT_TYPE_MATCH = 'ftbl-match';

export const isFtblPlayerProject = (projectType?: string | null): boolean =>
    projectType === FTBL_PROJECT_TYPE_PLAYER;

export const isFtblMatchProject = (projectType?: string | null): boolean =>
    projectType === FTBL_PROJECT_TYPE_MATCH;

export const isFtblProject = (projectType?: string | null): boolean =>
    isFtblPlayerProject(projectType) || isFtblMatchProject(projectType);
